(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/racing-game/components/statistics/assets/javascripts/overview.js') >= 0) return;  svs.modules.push('/modules/racing-game/components/statistics/assets/javascripts/overview.js');

'use strict';

const {
  getStatisticsNoDataMsg
} = svs.racing.common.strings;
const {
  statisticsService,
  statistics
} = svs.racing_game.components;
const {
  EmptyDataView
} = svs.racing.emptyDataView;
const {
  Skeleton,
  SkeletonCircle
} = svs.components.lbUi;
const {
  Attributes,
  Earnings,
  TopPositionsDiagram,
  YearlyEarnings
} = svs.racing_game.components.statistics;
const Overview = _ref => {
  let {
    participantId
  } = _ref;
  const [data, error, isLoading] = statistics.useStatisticsData(participantId, statisticsService.fetchParticipantStatistics);
  if (error) {
    return React.createElement("div", {
      className: "statistics-no-data"
    }, React.createElement(EmptyDataView, {
      label: getStatisticsNoDataMsg()
    }));
  }
  return React.createElement("div", {
    className: "overview-holder"
  }, isLoading ? React.createElement(React.Fragment, null, React.createElement(Skeleton, {
    height: 3,
    numLines: 2
  }), React.createElement(SkeletonCircle, {
    className: "margin-center margin-v-1",
    size: 250
  }), React.createElement(Skeleton, {
    height: 2,
    numLines: 3
  })) : React.createElement(React.Fragment, null, React.createElement("div", {
    className: "overview-attributes-holder"
  }, React.createElement(Attributes, {
    age: data.age,
    record: data.career ? data.career.recordTime : undefined,
    sex: data.sex
  })), React.createElement("div", {
    className: "overview-earnings-holder"
  }, React.createElement(Earnings, {
    career: data.career,
    yearlyEarnings: data.yearlyEarnings
  })), React.createElement(TopPositionsDiagram, {
    data: data.career.earnings
  }), React.createElement("div", {
    className: "overview-starter-holder"
  }, React.createElement(YearlyEarnings, {
    career: data.career,
    yearlyEarnings: data.yearlyEarnings
  })), React.createElement("div", {
    className: "overview-info-no-data margin-v-2"
  }, getStatisticsNoDataMsg())));
};
svs.racing_game.components.statistics.Overview = Overview;

 })(window);